import styled from '@emotion/styled';
import { Css, RefreshIconLight, TextButton } from '@/ui';
import { Color } from '../../../styles/Color';

export default function ReloadPageButton() {
	const reloadPage = () => {
		window.location.reload();
	};
	return (
		<StyledReloadButton type="button" onClick={reloadPage}>
			Reload Page <RefreshIconLight />
		</StyledReloadButton>
	);
}

const StyledReloadButton = styled(TextButton)`
	cursor: pointer;
	color: ${Color.PrimaryBlue};
	font-size: ${Css.pxToRem(16)};
	font-weight: 400;

	&:hover {
		color: ${Color.PrimaryBlue};
	}

	svg {
		path {
			fill: ${Color.PrimaryBlue};
		}
	}
`;
